import React from 'react'
import { useDropzone } from 'react-dropzone'
import { H5 } from '@blueprintjs/core'
import { Flex, Icon, LinkButton } from '@ui'

interface ISelectFileStepProps {
  onChange: (file: File) => void
}

export default function SelectFileStep({ onChange }: ISelectFileStepProps) {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop: (files: File[]) => onChange(files[0]),
    accept: {
      'text/csv': ['.csv'],
    },
  })

  return (
    <div>
      <H5>Upload CSV file</H5>
      <p>
        New data will overwrite existing data. You can access the old and new data by going to
        import history.
      </p>
      <Flex
        align="center"
        justify="center"
        direction="column"
        {...getRootProps()}
        style={{
          height: 200,
          border: `2px dashed ${isDragActive ? 'var(--border-color)' : 'transparent'}`,
          background: '#fafafa',
          borderRadius: 6,
        }}
      >
        <input {...getInputProps()} />
        <Icon
          name="cloud-upload"
          style={{
            fontSize: 34,
            color: isDragActive ? 'var(--primary-color)' : 'var(--grey)',
            marginBottom: 24,
          }}
        />
        <p style={{ textAlign: 'center' }}>
          Drag and drop
          <br /> or <LinkButton text="Browse" />
        </p>
      </Flex>
    </div>
  )
}
